import { Form } from 'formik';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 215px;
  width: 100%;
  max-width: 370px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
    min-height: calc(100vh - 356px);
    height: 100%;
  }
`;

export const ContainerButtons = styled.div`
  max-width: 370px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  display: grid;
  row-gap: 10px;
  margin-bottom: 20px;
  a {
    text-decoration: none;
    width: 100%;
  }
`;

export const FormContainer = styled(Form)`
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  max-width: 620px;
  width: 620px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  span {
    color: ${({ theme }) => theme.colors.darkBlue};
    font-size: 20px;
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
  }

  margin-bottom: 36px;
`;

export const ModalBody = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  max-width: 536px;
  margin-bottom: 36px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 1rem;
  span {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 21px;
  }

  a {
    color: ${({ theme }) => theme.colors.darkBlue};
    text-decoration: none;
    cursor: pointer;
  }
  a:first-child {
    margin-bottom: 12px;
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 620px;
    width: auto;
  }
`;

export const ButtonLink = styled.button`
  border: none;
  background: none;
  text-decoration: underline;
  color: #074f8c;
  font-size: 0.875rem;
  padding: 0;
`;

export const ContainerForm = styled.div`
  display: grid;
  row-gap: 20px;
  margin-bottom: 30px;

  p {
    font-size: 0.8125rem;
  }
`;

export const TokenLink = styled.a`
  cursor: pointer;
  color: #074f8c !important;
  font-size: 0.875rem;
  line-height: 17px;
`;

export const WrapSearchDocument = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  color: #0b24fb;
  margin-top: 5px;
  margin-bottom: 16px;

  div {
    cursor: pointer;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const SearchDocumentText = styled.span`
  text-decoration-line: underline;
  cursor: pointer;
`;

export const SearchDocumentIcon = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
`;
